// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Knmw","content":"styles_content__30XeH"};